import {m} from '@codeurs/front'
import InnerHTML from 'dangerously-set-html-content'
import {FunctionComponent} from 'react'
import {useLanguage} from 'util/i18n'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'

const styles = style('cookiedeclaration')

export type CookiesdeclarationBlockType = {
	cookiebot_id: string
}

export const CookiesdeclarationBlock: FunctionComponent<
	CookiesdeclarationBlockType
> = ({cookiebot_id}) => {
	const lang = useLanguage()
	if (!cookiebot_id) return null

	return (
		<Block class={styles}>
			<InnerHTML
				html={`<script id="CookieDeclaration" data-culture=${lang.toUpperCase()} src="https://consent.cookiebot.com/${cookiebot_id}/cd.js" type="text/javascript" async></script>`}
			/>
		</Block>
	)
}
